import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-error',
  templateUrl: './400error.component.html',
  styleUrls: ['./503error.component.css']
})
export class Error400Component implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}